<router-outlet></router-outlet>

<app-loader *ngIf="loaderVisibility"></app-loader>
